import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "form-input" }
const _hoisted_2 = { class: "label-input" }
const _hoisted_3 = ["value"]
const _hoisted_4 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", _hoisted_2, _toDisplayString(_ctx.label), 1),
    (_ctx.isPassword)
      ? (_openBlock(), _createElementBlock("input", {
          key: 0,
          type: "password",
          class: "input",
          onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.changeInput && _ctx.changeInput(...args))),
          value: _ctx.value,
          autocomplete: "off"
        }, null, 40, _hoisted_3))
      : (_openBlock(), _createElementBlock("input", {
          key: 1,
          type: "text",
          class: "input",
          onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.changeInput && _ctx.changeInput(...args))),
          value: _ctx.value,
          autocomplete: "off"
        }, null, 40, _hoisted_4)),
    _createElementVNode("p", {
      class: _normalizeClass([_ctx.hasError ? 'error' : 'no-error'])
    }, _toDisplayString(_ctx.error.esMessage), 3)
  ]))
}